import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import { formConvertErrorMessage } from "../../helpers/form_helper";
import { errorMessage } from "../../helpers/utils";
import routeLocalitiesService from "../../services/routeLocalitiesService";

export const useRouteLocalities = (params, onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation();

  return useQuery(
    ["route-localities", params],
    () => routeLocalitiesService.getRouteLocalities(params),
    {
      enabled: false,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.fetch_profile", {
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      // initialData: [],
      select: response => {
        const { data } = response;

        return {
          items: data?.items || [],
          params: data?._meta || {},
        };
      },
    }
  );
};
